import _ from 'lodash';
import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import responseKeyNormalizerMapping from './mapping';
import { MicroApp } from './micro';
import DrugFunctionBarService from './service/DrugFunctionBarService';
import DrugListOperationService from './service/DrugOperationService';
export default class DrugDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
        this.silencedUpdateQueryKeys = ['page', 'sort'];
        this.microapp = new MicroApp(this.microAppId);
    }
    get enabled() {
        return localStorage.getItem('workspaceDetail:drug') !== 'false';
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return DrugListOperationService;
    }
    get FunctionBarServiceClass() {
        return DrugFunctionBarService;
    }
    get isRefineEnabled() {
        return true;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 3,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailDrugRoot' },
        };
    }
    getReloadIdentifier(route) {
        const params = this._queryParamsNormalizer(route);
        return JSON.stringify(_.omit(params, this.silencedUpdateQueryKeys));
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(route) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(route),
            };
        }
        return {
            path: this.name,
            name: 'detailDrugRoot',
            component: () => import('./DrugDetail.vue'),
            props: getDetailPageProps,
        };
    }
    _preload() {
        this.microapp.preload();
        return Promise.resolve();
    }
}
